import { render, staticRenderFns } from "./DescriptionScrollView.vue?vue&type=template&id=6c079c1e&"
import script from "./DescriptionScrollView.vue?vue&type=script&lang=js&"
export * from "./DescriptionScrollView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports